module.exports = __webpack_public_path__ + "8395cbc00ed579a1aaa87f402d075136.jpg";